import HomePage from '@/pages/Home.vue';
import Teams from '@/pages/Teams.vue';
import RedirectPage from '@/pages/RedirectPage.vue';
import CalendarPage from '@/pages/CalendarPage.vue';
import NotificationsPage from '@/pages/NotificationsPage.vue';
import ContactsPage from '@/pages/ContactsPage.vue';
import EventsPage from '@/pages/EventsPage.vue';
import DealsPage from '@/pages/DealsPage.vue';
import GanttPage from '@/pages/GanttPage.vue';
import GuidesPage from '@/pages/guides/GuidesPage.vue';

export default [
  {
    path: '/',
    name: 'home',
    component: HomePage,
    meta: { title: 'TeRoom' },
  },
  {
    path: '/teams',
    name: 'teams',
    component: Teams,
    meta: { title: 'TeRoom' },
  },
  {
    path: '/redirect/:route',
    name: 'redirect',
    component: RedirectPage,
    meta: { needAuth: false },
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: CalendarPage,
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: NotificationsPage,
    meta: { title: 'Уведомления' },
  },
  {
    path: '/contacts',
    name: 'contacts',
    component: ContactsPage,
    meta: { title: 'Контакты' },
  },
  {
    path: '/events',
    name: 'events',
    component: EventsPage,
  },
  {
    path: '/deals',
    name: 'deals',
    component: DealsPage,
  },
  {
    path: '/gantt',
    name: 'gantt',
    component: GanttPage,
    meta: { title: 'Диаграмма Ганта', noLeftMenu: true },
  },
  {
    path: '/guides/:video?',
    name: 'guides',
    component: GuidesPage,
    meta: { title: 'Гайды', needAuth: false },
  },
];
